import React, { useState } from 'react';
import { TableContainer, Table, TableRow, TableCell, TableHead, TableBody, Paper } from '@material-ui/core';
import { FormControl, InputLabel, Select, MenuItem, makeStyles } from '@material-ui/core';
import t from '../common/localization';
import { formatPosition, formatDurationTime } from '../common/formatter';
import ReportFilter from './ReportFilter';
import ReportLayoutPage from './ReportLayoutPage';
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import Chip from "@material-ui/core/Chip";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { DataGrid } from '@material-ui/data-grid';

const useStyles = makeStyles((theme) => ({
selectField: {
  textAlign: "left",
  width: "180px",
  height: "50px",
  variant: "outlined",
  margin: "5px",
},
menuItemCss: {
    "&.Mui-selected": {
      background: "#361DDB",
      color: "white",
    },
    "&:hover": {
      background: "#b3aeae",
      color: "black",
    },
    "&:hover.Mui-selected": {
          background: "#361DDB",
          color: "white",
        },
  },
 tableRow: {
      "&$hover:hover": {
        backgroundColor: "#FFFFFF"
      }
    },
 tCell: {
         color: "white", backgroundColor: "#361DDB"
       },
  tContainer: {
       maxHeight: 690
     },
}));

const Filter = ({ setItems }) => {
  const dispatch = useDispatch();

  const [eventTypes, setEventTypes] = useState(['allEvents']);
  const classes = useStyles();

  const handleSubmit = async (
    deviceId,
    groupId,
    from,
    to,
    mail,
    headers,
    onResponseGet
  ) => {
    const query = new URLSearchParams({ from, to, mail });

    eventTypes.forEach((it) => query.append("type", it));
    let qString = query.toString();
    let deviceIdQuery = "";
    let groupIdQuery = "";

    deviceId.forEach((element) => {
      deviceIdQuery += `&deviceId=${element}`;
    });
    groupId.forEach((element) => {
      groupIdQuery += `&groupId=${element}`;
    });

    if (deviceIdQuery) {
      qString += deviceIdQuery;
    }
    if (groupIdQuery) {
      qString += groupIdQuery;
    }
    dispatch(showLoaderStateActions.addState(true));
    const response = await fetch(`/api/reports/events?${qString}`, { headers });
    const contentType = response.headers.get("content-type");
    onResponseGet(response);
    if (response.ok && contentType) {
      if (contentType === "application/pdf") {
        const name = "report.pdf";
        const blobUrl = URL.createObjectURL(await response.blob());
        // Create a link element
        const link = document.createElement("a");
        // Set link's href to point to the Blob URL
        link.href = blobUrl;
        link.download = name;
        // Append link to the body
        document.body.appendChild(link);
        // Dispatch click event on the link
        // This is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        // Remove link from body
        document.body.removeChild(link);
        dispatch(showLoaderStateActions.addState(false));
      } else if (contentType === "application/pdf") {
        const name = "report.pdf";
        const blobUrl = URL.createObjectURL(await response.blob());
        // Create a link element
        const link = document.createElement("a");
        // Set link's href to point to the Blob URL
        link.href = blobUrl;
        link.download = name;
        // Append link to the body
        document.body.appendChild(link);
        // Dispatch click event on the link
        // This is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        // Remove link from body
        document.body.removeChild(link);
        dispatch(showLoaderStateActions.addState(false));
      } else if (contentType === "application/json") {
        const resItem = await response.json();
        dispatch(showLoaderStateActions.addState(false));
        setItems(resItem);
      } else {
        dispatch(showLoaderStateActions.addState(false));
        let exportUrl = window.URL.createObjectURL(await response.blob());
        window.location.assign(exportUrl);
        // window.URL.revokeObjectURL(exportUrl);
      }
    } else {
      dispatch(showLoaderStateActions.addState(false));
    }
  };

  return (
    <ReportFilter handleSubmit={handleSubmit} reportHeader="Event Report" >
      <FormControl className={classes.selectField}>
        <Select
        disableUnderline={true}
        value={eventTypes}
        inputProps={{ "aria-label": "none" }}
        onChange={e => setEventTypes(e.target.value)}

 multiple>
          <MenuItem className={classes.menuItemCss} value="allEvents">{t('eventAll')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="deviceOnline">{t('eventDeviceOnline')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="deviceUnknown">{t('eventDeviceUnknown')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="deviceOffline">{t('eventDeviceOffline')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="deviceInactive">{t('eventDeviceInactive')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="deviceMoving">{t('eventDeviceMoving')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="deviceStopped">{t('eventDeviceStopped')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="deviceOverspeed">{t('eventDeviceOverspeed')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="deviceFuelDrop">{t('eventDeviceFuelDrop')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="commandResult">{t('eventCommandResult')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="geofenceEnter">{t('eventGeofenceEnter')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="geofenceExit">{t('eventGeofenceExit')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="alarm">{t('eventAlarm')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="ignitionOn">{t('eventIgnitionOn')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="ignitionOff">{t('eventIgnitionOff')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="maintenance">{t('eventMaintenance')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="textMessage">{t('eventTextMessage')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="driverChanged">{t('eventDriverChanged')}</MenuItem>
          <MenuItem className={classes.menuItemCss} value="commandSend">{t('eventCommandSend')}</MenuItem>
        </Select>
      </FormControl>
    </ReportFilter>
  );
}

const EventReportPage = () => {

  const [items, setItems] = useState([]);
  const classes = useStyles();
  let mainData = [];
  const setRecursiveData = (newItems) => {
    setTimeout(() => {
      let hasMore = mainData.length +1  < newItems.length;
      const list = newItems.slice(0, mainData.length + 1);
      mainData = list;
      setItems(list);
      if (hasMore) setRecursiveData(newItems);
    }, 0);
  }


  const setData = (newItems)=> {
    mainData = [];
    setRecursiveData(newItems);
  }

  const columns = [
    { field: "deviceName", headerName: t("settingsVehicleNumber"), flex: 1 },
    { field: "type", headerName: t("sharedType"), flex: 1 },
    { 
      field: "serverTime", 
      headerName: t("positionFixTime"),
      flex: 1,
      renderCell: (params) => <Chip
        label={params.value}
        icon={<AccessTimeIcon />}
        size="small"
        color="secondary"
        style={{
        backgroundColor: "#EFEBFC",
        color: "#623DE6",
        borderRadius: 3,
        margin: "5px",
      }}
      />,
    },
    { field: "geofenceName", headerName: t("sharedGeofence"), flex: 1 },
    { field: "cmdType", headerName: t("sharedCmdType"), flex: 1 },
    { field: "cmdSendByName", headerName: t("sharedCmdOperator"), flex: 1 },
    { field: "maintenanceName", headerName: t("sharedMaintenance"), flex: 1 },
  ];  

  // Build DataGrid rows
  const gridRows = items.map((item, index) => ({
    id: index, // required unique id for DataGrid
    deviceName: item.attributes.deviceName,
    type: item.type,
    serverTime: formatPosition(item, 'serverTime'),
    geofenceName: item.attributes.geofenceName,
    cmdType: item.attributes.cmdType,
    cmdSendByName: item.attributes.cmdSendByName,
    maintenanceName: item.attributes.maintenanceName,
  }));  

  return (
    <ReportLayoutPage filter={<Filter setItems={setData} />}>
      {/* <TableContainer className = {classes.tContainer} component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead style={{ backgroundColor: "#361DDB"}}>
            <TableRow>
              <TableCell className = {classes.tCell}>{t('settingsVehicleNumber')}</TableCell>
              <TableCell className = {classes.tCell}>{t('sharedType')}</TableCell>
              <TableCell className = {classes.tCell}>{t('positionFixTime')}</TableCell>
              <TableCell className = {classes.tCell}>{t('sharedGeofence')}</TableCell>
              <TableCell className = {classes.tCell}>{t('sharedCmdType')}</TableCell>
              <TableCell className = {classes.tCell}>{t('sharedCmdOperator')}</TableCell>
              <TableCell className = {classes.tCell}>{t('sharedMaintenance')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <TableRow
              hover
              key={item.id}
              className={classes.tableRow}>
              <TableCell><b>{item.attributes.deviceName}</b></TableCell>
              <TableCell>{item.type}</TableCell>
              <TableCell>
                         <Chip
                           label={formatPosition(item, 'serverTime')}
                           icon={<AccessTimeIcon />}
                           size="small"
                           color="secondary"
                           style={{
                           backgroundColor: "#EFEBFC",
                           color: "#623DE6",
                           borderRadius: 3,
                           margin: "5px",
                          }}
                         />
                </TableCell>
                <TableCell>{item.attributes.geofenceName }</TableCell>
                <TableCell>{item.attributes.cmdType}</TableCell>
                <TableCell>{item.attributes.cmdSendByName}</TableCell>
                <TableCell>{ item.attributes.maintenanceName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      <DataGrid
        rows={gridRows}
        columns={columns}
        disableSelectionOnClick
        autoHeight={false}
        pageSize={50}
        rowsPerPageOptions={[50, 100, 500]}
        style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
        pagination
      />
    </ReportLayoutPage>
  );
}

export default EventReportPage;
